import { render } from "./emailEdit.vue?vue&type=template&id=e8614412"
import script from "./emailEdit.vue?vue&type=script&lang=ts"
export * from "./emailEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script